namespace globalEnum {
  export enum unitType {
    roll = 'رولی',
    box = 'قوطی'
  }
  export enum entityType{
    product = 'Product',
    brand = 'Brand',
    category = 'Category',
    car = 'Car',
  }

  export enum userRole{
    user = 'USER',
    superAdmin = 'SUPER_ADMIN',
    warehouse = 'WAREHOUSE',
    bearingCommerce = 'BEARINGCOMMERCE',
    feltBowlCommerce = 'FELTBOWLCOMMERCE'
  }

  export enum orderStatus  {
    Created = 'سبد خرید',
    WaitForCommerceBearingApproval = 'WaitForCommerceBearingApproval',
    WaitForCommerceFeltBowlApproval = 'WaitForCommerceFeltBowlApproval',
    WaitForWarehouseApproval = 'WaitForWarehouseApproval',
    // WarehouseApproved = 'WarehouseApproved',
    Sent = 'Sent',
    UnapprovedCommerceBearing = 'UnapprovedCommerceBearing',
    UnapprovedCommerceFeltBowl = 'UnapprovedCommerceFeltBowl',
    EditedOrder = 'EditedOrder',

  };

  export enum orderStatus2  {
    Created = 'سبد خرید',
    WaitForCommerceBearingApproval = 'در انتظار تایید بازرگان بلبرینگ',
    WaitForCommerceFeltBowlApproval = 'در انتظار تایید بازرگان کاسه نمد',
    WaitForWarehouseApproval = 'در انتظار تایید انبار',
    // WarehouseApproved = 'تاییدیه انبار',
    Sent = 'ارسال شده',
    UnapprovedCommerceBearing = 'عدم تایید بازرگان بلبرینگ',
    UnapprovedCommerceFeltBowl = 'عدم تایید بازرگان کاسه نمد',
    EditedOrder = 'اصلاح شده',

  };

}

export default globalEnum;
